/**
 * @file: 面板通过事件，或者快捷键驱动交互
 * @author: xiaolong.huang@dmall.com
 */

import TransformDriver from './transform';
import AddDriver from './add';
import RemoveDriver from './remove';
import HistoryDriver from './history';
import ChangeSurfaceDriver from './changeSurface';
import LayerAlignDriver from './layerAlign';
import ShortMoveDriver from './shortMove';
import CreateTextareaDriver from './createTextarea';
import LayerGroupDriver from './layerGroup';
import DbClickDriver from './dbClick';
import CopyDriver from './copy';
import ContextmenuDriver from './contextmenu';
import SaveDriver from './save';
import RefreshDriver from './refresh';
import SelectDriver from './select';
import CabinetTransferDriver from './cabinetTransfer';
import RefreshColor from './refreshColor';

function init(stageCube: CubeNode): void {
    // 画布矩阵变换
    TransformDriver.init(stageCube);

    // 组件新增
    AddDriver.init();

    // 删除
    RemoveDriver.init();

    // 撤销
    HistoryDriver.init();

    // 数字快捷键修改面宽
    ChangeSurfaceDriver.init();

    // 层板对齐
    LayerAlignDriver.init();

    // 快捷移动
    ShortMoveDriver.init();

    // 文本框快捷创建
    CreateTextareaDriver.init();

    // 层板编组
    LayerGroupDriver.init();

    // 双击cube
    DbClickDriver.init();

    // 复制、粘贴、剪切
    CopyDriver.init();

    // 右键菜单
    ContextmenuDriver.init();

    // 快捷保存
    SaveDriver.init();

    // 刷新
    RefreshDriver.init();

    // 选择器
    SelectDriver.init();

    // 跨卧柜
    CabinetTransferDriver.init();

    // 突出显示刷新
    RefreshColor.init();
}

export default {
    init
};
